import { MediaLibraryState } from '../types'
import { MediaLibraryEssence } from '@/types/mediaLibrary'

const pendingRequests =
  (state: MediaLibraryState) =>
  (essence: MediaLibraryEssence): number[] => {
    return state.value.get(essence)?.pendingRequests ?? []
  }

export default pendingRequests
